<template>
    <div class="footer">
          Footer
    </div>
</template>

<script scoped>
    export default {
        name: 'Footer',
        data() {
            return {
             
            }
        },
        methods: {
           
        },
    }
</script>

<style scoped>

</style>